import { actions, selectors } from 'data'
import React, { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'

import TwoFactor from './template'

export type Props = ConnectedProps<typeof connector>

const TwoFactorContainer = (props: Props) => {
  useEffect(() => {
    return props.onUnmount
  }, [])

  return (
    <TwoFactor
      {...props}
      handleSubmit={(e) => {
        e.preventDefault()
        props.handleSubmit(props.step)
      }}
    />
  )
}

const mapStateToProps = (state) => ({
  email: selectors.auth.getEmail(state),
  initialValues: selectors.twoFactor.getInitialValues(state),
  isLoading: selectors.twoFactor.isLoading(state),
  step: selectors.twoFactor.getStep(state)
})

const mapDispatchToProps = (dispatch) => ({
  handleSubmit: (step) => {
    dispatch(actions.twoFactor.submit(step))
  },
  onUnmount: () => {
    dispatch(actions.auth.removeTotpConfig())
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(TwoFactorContainer)
